
Fastweb.Admin.FeaturedAwardsForm = (function($) {

  init = function() {

    initializeAwardsAutocomplete($(".linked_award_search"));
    $("a.fields_link").mouseup(function() {
      setTimeout(function(){initializeAwardsAutocomplete($(".linked_award_search").last());}, 100);
    });

  };


  function initializeAwardsAutocomplete(element) {
    $(element).keyup(function() {
      Fastweb.Autocomplete.triggerAutocomplete(this)
    });

    $(element).on('autocompleteOptions', function(event, data) {
      return $.map( data, function( item ) {
        return { label: item.name + " - #" + item.id + " - (" + item.status_txt + ")", value: item.id };
      });
    });

    var lookup = $(element).attr('data-autocomplete-lookup');
    $(element).on('autocompleteSelect', function(event, selected) {
      $(this).siblings(".featured_award_id").attr("value", selected.item.value);
      $(this).siblings(".linked_award_name").html(selected.item.label);
    });
  }

  return {init: init}

})(jQuery);
